import libForm from "../../../../util/libForm";
import RadioInput from "../../../../components/inputs/radio";
import TextInput from "../../../../components/inputs/text";
import { useEffect } from "react";
import { IndexHook } from "../../../../components/filter/register-basic/hook";
import { Switch } from "@mui/material";
import { BtnSearch } from "../../../../components/button/button-search";
import HeaderFilter from "../../../../components/header/filter";

const FilterStoreHours = ({ options, handleSubmitModalFilter, reloadFilter }) => {
	const parameters = options.parametersFilter;

	const {
		errors,
		isSubmitting,
		register,
		handleSubmit,
		handleOnSubmit,
		paramSelected,
		setValue,
		control,
		Controller,
	} = IndexHook({ options, handleSubmitModalFilter });

	useEffect(() => {
		try {
			if (reloadFilter) {
				Object.keys(reloadFilter).forEach((field) => {
					setValue(field, reloadFilter[field]);
				});
			}
		} catch (error) {}
	}, [reloadFilter]);

	// Força o valor "Domingo" se o parâmetro for dia_semana e o valor estiver vazio
	useEffect(() => {
		if (paramSelected?.value === "dia_semana") {
			// Se o valor estiver vazio ou não for um dos dias, define Domingo
			const dias = ["Domingo", "Segunda-feira", "Terça-feira", "Quarta-feira", "Quinta-feira", "Sexta-feira", "Sábado"];
			// setValue só será chamado se necessário para evitar loops
			setValue("paramValue", "Domingo");
		} else {
			// Limpa o valor ao trocar para outro tipo de filtro (ex: Texto livre)
			setValue("paramValue", "");
		}
	}, [paramSelected?.value]);

	const diasSemana = [
		{ id: 1, descricao: "Domingo" },
		{ id: 2, descricao: "Segunda-feira" },
		{ id: 3, descricao: "Terça-feira" },
		{ id: 4, descricao: "Quarta-feira" },
		{ id: 5, descricao: "Quinta-feira" },
		{ id: 6, descricao: "Sexta-feira" },
		{ id: 7, descricao: "Sábado" },
	];

	return (
		<div className="">
			<form onSubmit={handleSubmit(handleOnSubmit)} action="submit">
				<HeaderFilter title={options.title} />

				<div className="border-bottom">
					<div className="row mt-2">
						{parameters.map((item) => (
							<RadioInput key={item.id} item={item} id={"param"} register={register} control={control} />
						))}
					</div>
					<div className="flex-wrap ">
						<div className="check-input d-flex align-items-center justify-content-end">
							<Controller
								name="active"
								control={control}
								defaultValue={true}
								render={({ field }) => (
									<Switch
										checked={field.value}
										onChange={(e) => field.onChange(e.target.checked)}
										inputProps={{
											"aria-label": "Ativos",
										}}
									/>
								)}
							/>
							<label htmlFor="active">Ativo</label>
							{errors.active && <p className="errors">{errors.active.message}</p>}
						</div>
					</div>

					{paramSelected?.value === "dia_semana" ? (
						<div className="input-select-box d-flex flex-column mt-2">
							<label htmlFor="paramValue">{paramSelected.label}</label>
							<select {...register("paramValue")} onKeyDown={(e) => libForm.EnterTab(e)}>
								{diasSemana.map((dia) => (
									<option key={dia.id} value={dia.descricao}>
										{dia.descricao}
									</option>
								))}
							</select>
							{errors.paramValue && <p className="errors">{errors.paramValue.message}</p>}
						</div>
					) : (
						<TextInput
							label={paramSelected.label}
							id="paramValue"
							register={register}
							errors={errors}
							onKeyDown={libForm.EnterTab}
							autoFocus={true}
							className={"mt-2"}
						/>
					)}
				</div>
				<footer>
					<div></div>
					<BtnSearch isSubmitting={isSubmitting} />
				</footer>
			</form>
		</div>
	);
};

export default FilterStoreHours;
